import AnatomyV2SocialProof from '~/pages/anatomyV2/socialProof/libs/components/AnatomyV2SocialProof'
import { TPageProps } from '~/shared/types/commonTypes'

const SocialProofAnatomyV2 = (props: TPageProps) => (
  <AnatomyV2SocialProof {...props} />
)

export default SocialProofAnatomyV2
